import React from 'react'
import { Link } from 'react-router-dom'
import { PageHero, Prose } from './_shared'
import { OWNER_EMAIL } from '../../components/Footer'

const UPDATED = 'June 2026'

export default function Privacy() {
  return (
    <>
      <PageHero kicker="Legal" title="Privacy" lede={`How serenDPT handles your information. Last updated ${UPDATED}.`} />
      <Prose>
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          serenDPT is a personal, self-hosted platform. This page describes how the software is
          designed to handle data; it is provided in good faith and is not a substitute for
          formal legal advice. Review it against your own deployment before relying on it.
        </div>

        <h2>What the platform stores</h2>
        <ul>
          <li><strong>Account &amp; portfolio data</strong> — your login, broker connections, holdings, orders and snapshots, kept in your own database.</li>
          <li><strong>Broker tokens</strong> — access tokens needed to read holdings and (where enabled) place orders, held to operate the integrations you connect.</li>
          <li><strong>Workspace content</strong> — notes, spreadsheets and file attachments, written to disk on your own server. There is no third-party notes database.</li>
        </ul>

        <h2>What it does not do</h2>
        <ul>
          <li>It does <strong>not</strong> sell, rent, or share your data with advertisers or data brokers.</li>
          <li>It does <strong>not</strong> profile you for marketing.</li>
          <li>It does <strong>not</strong> place trades without your action through your own connected broker.</li>
        </ul>

        <h2>Third-party services</h2>
        <p>To deliver specific features, the platform may exchange the minimum necessary data with:</p>
        <ul>
          <li><strong>Zerodha Kite Connect</strong> — holdings, positions and order placement.</li>
          <li><strong>AngelOne SmartAPI</strong> — read-only live price ticks.</li>
          <li><strong>AMFI / MFAPI</strong> — public mutual-fund NAV and scheme data.</li>
          <li><strong>OpenAI, Google News, Telegram, Email</strong> — only for the features that use them, when you enable them.</li>
        </ul>
        <p>Each of these operates under its own terms and privacy policy.</p>

        <h2>Security</h2>
        <p>
          Access is protected by authentication, and workspace writes are atomic and versioned to
          prevent data loss or corruption. As with any self-hosted software, the security of your
          deployment, server and credentials is ultimately in your hands.
        </p>

        <h2>Your control</h2>
        <p>
          Because data lives in your own database and on your own disk, you can export, back up or
          delete it directly. Disconnecting a broker removes its stored tokens.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about privacy? <Link to="/contact">Get in touch</Link> or email{' '}
          <a href={`mailto:${OWNER_EMAIL}`}>{OWNER_EMAIL}</a>.
        </p>
      </Prose>
    </>
  )
}
